module.exports = __webpack_public_path__ + "oktaVerify_ico@2x.17c181985b26d223a68e6eb81226a5f9.png";